import Svg from '../generated/Warning';
import { Icon, type IconProps } from './Icon';

export const WarningIcon = (props: IconProps) => (
    <Icon inheritColors={false} component={Svg} name="warning" {...props} />
);
